// MassageDerniereMinute: English labels for the custom listing fields configured in
// Sharetribe Console (Build > Content > Listing fields). Console only stores one language per
// field, so this dictionary supplies the English versions used on the samedaymassage.com
// deployment (REACT_APP_FORCE_LOCALE=en), applied in src/util/configHelpers.js.
//
// Keyed by the field's Console `key`. Fields/options not listed here (or added in Console
// later) simply keep showing their original Console label until this file is updated.
//
// "association_professionnelle" only gets its field label translated: its option labels
// (RMPQ, FQM, RMQ, RITMA) are professional association names, which don't get translated.
// The "verifie" field (the "Vérifié" word) is already handled separately in
// src/util/verification.js.
export default {
  association_professionnelle: {
    label: 'Professional association',
  },
  type_massage: {
    label: 'Type of massage',
    options: {
      suedois: 'Swedish massage',
      therapeutique: 'Therapeutic massage',
      prenatal: 'Prenatal massage',
      sportif: 'Sports massage',
      pierres_chaudes: 'Hot stone massage',
      reflexologie: 'Reflexology',
      relaxant: 'Relaxation massage',
      deep_tissue: 'Deep tissue massage',
      cranien: 'Cranial massage',
      drainage_lymphatique: 'Lymphatic drainage',
      californien: 'Californian massage',
      ventouses: 'Cupping',
      guasha: 'Gua sha',
      lomi_lomi: 'Lomi lomi',
    },
  },
  duree_soin: {
    label: 'Treatment duration',
    options: {
      '30min': '30 minutes',
      '60min': '60 minutes',
      '90min': '90 minutes',
      '120min': '120 minutes',
    },
  },
  deplacement_domicile: {
    label: 'Mobile / house calls',
    options: {
      oui: 'Yes',
      non: 'No',
    },
  },
  langues: {
    label: 'Languages spoken',
    options: {
      francais: 'French',
      anglais: 'English',
      espagnol: 'Spanish',
      mandarin: 'Mandarin',
      arabe: 'Arabic',
      portugais: 'Portuguese',
      italien: 'Italian',
      autre: 'Other',
    },
  },
  mode_paiement: {
    label: 'Accepted payment methods',
    options: {
      interac: 'Interac e-Transfer',
      comptant: 'Cash',
      debit: 'Debit',
      credit: 'Credit card',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
    },
  },
  disponibilite: {
    label: 'Availability',
    options: {
      disponible: 'Available today',
      'non-disponible': 'Not currently available',
    },
  },
};
